export default () => ({
  '1659358114481': {
    id: 1659358114481,
    titulo: 'SOBRE O LOCAL',
    perguntas: {
      '1659358125862': {
        id: 1659358125862,
        titulo: 'É POSSÍVEL REALIZAR A ENTREGA?',
        tipo: 'local_acessivel',
        obrigatorio: true,
        min_fotos: 1,
        order: 0,
      },
    },
    order: 0,
  },
  '1659358239096': {
    id: 1659358239096,
    titulo: 'SOBRE A ENTREGA',
    perguntas: {
      '1659358274088': {
        id: 1659358274088,
        titulo: 'HOUVE RECUSA EM RECEBER O DOCUMENTO?',
        tipo: 'sim_nao',
        obrigatorio: false,
        min_fotos: 0,
        acoes: [
          {
            op: {
              eq: true,
            },
            run: ['notificacao.comentar'],
          },
        ],
        order: 0,
      },
      '1659358307689': {
        id: 1659358307689,
        titulo: 'MOTIVO DA RECUSA',
        tipo: 'text',
        obrigatorio: false,
        min_fotos: 0,
        condicao: {
          grupo_id: 1659358239096,
          pergunta_id: 1659358274088,
          operacao: 'eq',
          resposta: true,
        },
        acoes: [
          {
            op: {
              not_empty: null,
            },
            run: ['notificacao.comentar'],
          },
        ],
        order: 1,
      },
      '1659358358618': {
        id: 1659358358618,
        titulo: 'DOCUMENTO ENTREGUE A:',
        tipo: 'radio',
        obrigatorio: false,
        min_fotos: 0,
        alternativas: {
          '1659358367301': {
            id: 1659358367301,
            titulo: 'PROPRIETÁRIO (A)/ SÓCIO (A)',
            order: 0,
          },
          '1659358374012': {
            id: 1659358374012,
            titulo: 'CÔNJUGE',
            order: 1,
          },
          '1659358381483': {
            id: 1659358381483,
            titulo: 'FILHOS (AS)',
            order: 2,
          },
          '1659358387001': {
            id: 1659358387001,
            titulo: 'PARENTE',
            order: 3,
          },
          '1659358392179': {
            id: 1659358392179,
            titulo: 'PORTEIRO/ZELADOR',
            order: 4,
          },
          '1659358398441': {
            id: 1659358398441,
            titulo: 'GERENTE/COLABORADOR DA EMPRESA',
            order: 5,
          },
          '1659358405241': {
            id: 1659358405241,
            titulo: 'CONTADOR/PROCURADOR',
            order: 6,
          },
          '1659358411202': {
            id: 1659358411202,
            titulo: 'LOCATÁRIO (A)',
            order: 7,
          },
        },
        condicao: {
          grupo_id: 1659358239096,
          pergunta_id: 1659358274088,
          operacao: 'eq',
          resposta: false,
        },
        acoes: [
          {
            op: {
              eq: 1659358367301,
            },
            run: ['notificacao.comentar'],
          },
          {
            op: {
              eq: 1659358374012,
            },
            run: ['notificacao.comentar'],
          },
          {
            op: {
              eq: 1659358381483,
            },
            run: ['notificacao.comentar'],
          },
          {
            op: {
              eq: 1659358387001,
            },
            run: ['notificacao.comentar'],
          },
          {
            op: {
              eq: 1659358392179,
            },
            run: ['notificacao.comentar'],
          },
          {
            op: {
              eq: 1659358398441,
            },
            run: ['notificacao.comentar'],
          },
          {
            op: {
              eq: 1659358405241,
            },
            run: ['notificacao.comentar'],
          },
          {
            op: {
              eq: 1659358411202,
            },
            run: ['notificacao.comentar'],
          },
        ],
        order: 2,
      },
      '1659358469213': {
        id: 1659358469213,
        titulo: 'NOME e CPF DO RECEBEDOR (NOME - CPF)',
        tipo: 'text',
        obrigatorio: true,
        min_fotos: 1,
        condicao: {
          grupo_id: 1659358239096,
          pergunta_id: 1659358274088,
          operacao: 'eq',
          resposta: false,
        },
        acoes: [
          {
            op: {
              not_empty: null,
            },
            run: ['notificacao.comentar', 'notificacao.ciencia'],
          },
        ],
        order: 3,
      },
      '1659358553213': {
        id: 1659358553213,
        titulo: 'OBSERVAÇÕES',
        tipo: 'text',
        obrigatorio: false,
        min_fotos: 0,
        acoes: [
          {
            op: {
              not_empty: null,
            },
            run: ['notificacao.comentar'],
          },
        ],
        order: 4,
      },
    },
    condicao: {
      grupo_id: 1659358114481,
      pergunta_id: 1659358125862,
      operacao: 'eq',
      resposta: true,
    },
    order: 1,
  },
})
